
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.362 2.057a3.08 3.08 0 012.97 2.11 3.5 3.5 0 013.302 3.448 3.367 3.367 0 01-.402 1.582 4.423 4.423 0 012.211 3.808c0 2.452-2.046 4.443-4.57 4.443a4.68 4.68 0 01-1.44-.228 3.593 3.593 0 01-1.436.684l-.001 3.24a.8.8 0 11-1.6 0v-3.222a3.58 3.58 0 01-1.567-.79c-.543.21-1.12.318-1.703.316-2.523 0-4.57-1.989-4.57-4.443a4.423 4.423 0 012.276-3.85 3.367 3.367 0 01-.338-1.472 3.51 3.51 0 013.56-3.451c.135 0 .27.007.403.022a3.08 3.08 0 012.905-2.197zm.024 1.6a1.48 1.48 0 00-1.396 1.055 1.6 1.6 0 01-1.708 1.132 2.25 2.25 0 00-.25-.013c-1.054-.015-1.92.825-1.938 1.853 0 .268.061.532.178.772a1.6 1.6 0 01-.663 2.098 2.82 2.82 0 00-1.452 2.45c0 1.56 1.32 2.844 2.974 2.844.383 0 .763-.07 1.12-.208a1.6 1.6 0 011.626.283c.155.135.33.244.518.325v-1.179l-1.723-1.735a.8.8 0 011.136-1.127l.588.592v-1.804a.8.8 0 01.7-.794l.1-.006a.8.8 0 01.8.8v1.858l.662-.652a.8.8 0 011.124 1.139l-1.786 1.76v1.128c.1-.043.196-.093.287-.152l.159-.113a1.6 1.6 0 011.483-.266c.306.1.627.15.949.15 1.649 0 2.97-1.284 2.97-2.835a2.823 2.823 0 00-1.412-2.43 1.6 1.6 0 01-.609-2.144c.138-.255.21-.54.211-.803a1.9 1.9 0 00-1.793-1.871 1.6 1.6 0 01-1.429-1.094 1.48 1.48 0 00-1.426-1.015z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    